import { NgModule } from '@angular/core';
import { SeoComponent } from './seo.component';

@NgModule({
  declarations: [SeoComponent],
  exports: [SeoComponent],
})
export class SeoModule {}
